(function (Drupal, $) {
  Drupal.behaviors.page_sidebar = {
    attach: function (context) {
      $(function() {
        $(once('filter-toggle-click', '.filter-toggle', context)).on('click', function () {
          var $this = $(this);
          $this.toggleClass('closed');
          $this.parent().toggleClass('closed');
          $this.siblings('.filter-toggle__content').slideToggle(300);
        })

        $(once('filter-title-click', '.filter-title', context)).on('click', function() {
          if($(window).width() < 1024) {
            $(this).siblings('.global-filter').slideToggle(300);
          }
        })

        //handle filter opens when value is passed in url
        var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
        
        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');
          
          sParameterName[0] = sParameterName[0].split('%')[0];
          
          if (sParameterName[1]) {
            var filterElem = $('.filter-toggle.'+sParameterName[0]);
            $(filterElem).removeClass('closed');
            $(filterElem).parent().removeClass('closed');
            $(filterElem).siblings('.filter-toggle__content').slideDown(300);
          }
        } 
      });      
    }
  }
})(Drupal, jQuery);